/* What each side's food is called on screen, in one glyph.

Both sides hold the same number — `food` on the wire, the stockpile a march prepays and an army
eats — and each side reads it as its own thing: the horde's is meat, humanity's is a crop. The
glyph is here rather than inline at each screen because the same coin shows up in the top bar, a
city's income line, a route's provisions and a unit's upkeep, and a player who sees two different
pictures for one number has to work out that they are the same number.

🌽 for humanity since 2026-09-10 (owner), replacing a drawn icon; 🥩 for the horde since
2026-09-09, replacing one too. Anything with no side yet reads as the horde's, which is what the
top bar did before either of them. */

export const FOOD_ICON = { human: "🌽", zombie: "🥩" }

export const foodIcon = (team) => FOOD_ICON[team] || FOOD_ICON.zombie
